module.exports = __webpack_public_path__ + "static/media/expand.57ccd442.svg";